
import IconArrowUp from '~/components/icon/IconArrowUp.vue';

export default {
    name: 'Business',
    data() {
        return {
            sections: [
                {
                    sections: [
                        {
                            title: this.$t('business.heading_2'),
                            text: this.$t('business.text_2'),
                        },
                        {
                            title: this.$t('business.heading_3'),
                            text: this.$t('business.text_3'),
                        },
                        {
                            title: this.$t('business.heading_4'),
                            text: this.$t('business.text_4'),
                        },
                    ],
                },
                {
                    title: this.$t('business.heading_15'),
                    cover: `${this.$config.cdn_domain}/images/cover/latest-reports`,
                    coverMobile: `${this.$config.cdn_domain}/images/cover/latest-reports-small`,
                    text: this.$t('business.text_15'),
                },
                {
                    title: this.$t('business.heading_14'),
                    text: this.$t('business.text_14'),
                    link: {
                        class: 'btn-primary',
                        text: this.$t('business.press'),
                        url: 'press',
                    },
                },
                {
                    title: this.$t('business.heading_8'),
                    image: '/images/business/business_why-should-you-join',
                    imageAlt: this.$t('business.image_alt_1'),
                    text: this.$t('business.text_8'),
                },
                {
                    title: this.$t('business.heading_9'),
                    image: '/images/business/boost_your_credibility',
                    imageAlt: this.$t('business.image_alt_2'),
                    text: this.$t('business.text_9'),
                },
                {
                    title: this.$t('business.heading_10'),
                    image: '/images/business/business_find-jobs',
                    imageAlt: this.$t('business.image_alt_3'),
                    text: this.$t('business.text_10'),
                },
                {
                    title: this.$t('business.heading_5'),
                    icon: IconArrowUp,
                    text: this.$t('business.text_5'),
                },
                {
                    title: this.$t('business.heading_11'),
                    image: '/images/business/business_coverage',
                    imageAlt: this.$t('business.image_alt_4'),
                    text: this.$t('business.text_11'),
                },
                {
                    title: this.$t('business.heading_12'),
                    image: '/images/business/business_manage-bookings',
                    imageAlt: this.$t('business.image_alt_5'),
                    text: this.$t('business.text_12'),
                },
                {
                    title: this.$t('business.heading_13'),
                    image: '/images/business/business_quote-jobs',
                    imageAlt: this.$t('business.image_alt_6'),
                    text: this.$t('business.text_13'),
                },
                {
                    title: this.$t('business.heading_7'),
                    icon: '',
                    text: this.$t('business.text_7'),
                    link: {
                        class: 'btn-primary',
                        text: this.$t('business.register'),
                        url: 'business-register',
                    },
                },
            ],
        };
    },
};
